import { useCallback, useEffect, useState } from "react";
import { EADDRESS_TYPES } from "@constants";
import { getContactAddressRoute } from "@api-routes/contacts";
import { useUserContext } from "@hook/useUserContext";
import { IUserAddress } from "@common/Eircode/interface/IAddressForm";
import { IUserAddressPayload } from "@features/Profile/UserDetails/mappers/updateUserAddressMapper";
import { useFetch } from "@common/hook/useFetch";

export const useGetAddressType = (addressType: EADDRESS_TYPES) => {
    const [addressField, setAddressField] = useState<IUserAddressPayload>();
    const { username: contactUuid } = useUserContext();

    const [getUserAddressState, { get }] = useFetch();

    const getUserAddress = useCallback(() => {
        if (contactUuid) {
            get<IUserAddress>(getContactAddressRoute(addressType, contactUuid)).then((contactAddressResponse) => {
                if (contactAddressResponse) {
                    setAddressField(contactAddressResponse);
                }
            });
        }
    }, [addressType, contactUuid, get]);

    useEffect(getUserAddress, [getUserAddress]);

    return { getUserAddress, getUserAddressState, addressField };
};
